import { Link } from 'expo-router';
import { useQuery } from 'urql';
import Card from '@/components/UI/Card';
import Item from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';
import { graphql } from '@/gql/graphql';
import useUserId from '@/hooks/useUserId';

const GetOrganizationUpdateDangerZone = graphql(/* GraphQL */ `
  query GetOrganizationUpdateDangerZone(
    $organizationId: uuid!
    $personId: String!
  ) {
    event_by_pk(id: $organizationId) {
      id
      permissions
      ownerId: owner_id
      parentId: parent_id
      event_people(limit: 1, where: { person_id: { _eq: $personId } }) {
        event_id
        person_id
      }
    }
  }
`);

export default function OrganizationUpdateDangerZone({
  organizationId,
}: {
  organizationId: string;
}) {
  const userId = useUserId();

  const [{ data }] = useQuery({
    query: GetOrganizationUpdateDangerZone,
    variables: { organizationId, personId: userId },
  });

  const organization = data?.event_by_pk;

  const permissionChecks = {
    canTransfer: organization?.ownerId === userId,
    canDelete: organization?.permissions?.delete,
    canLeave:
      organization &&
      !organization.parentId &&
      organization.ownerId !== userId &&
      organization.permissions?.delete_self &&
      organization.event_people.length === 1,
  };

  const hasPermissions = Object.values(permissionChecks).some(Boolean);

  return hasPermissions ? (
    <Card>
      {permissionChecks.canTransfer ? (
        <Link
          href={{
            pathname: '/organization/[organizationId]/edit/transfer',
            params: {
              organizationId,
            },
          }}
          asChild
        >
          <Item>
            <Icon name="swap-horizontal-outline" />
            <Text>Transfer Ownership…</Text>
          </Item>
        </Link>
      ) : null}
      {permissionChecks.canDelete ? (
        <Link
          href={{
            pathname: '/organization/[organizationId]/edit/delete',
            params: {
              organizationId,
            },
          }}
          asChild
        >
          <Item>
            <Icon name="trash-outline" />
            <Text>Delete…</Text>
          </Item>
        </Link>
      ) : null}
      {permissionChecks.canLeave ? (
        <Link
          href={{
            pathname: '/organization/[organizationId]/edit/leave',
            params: {
              organizationId,
            },
          }}
          asChild
        >
          <Item>
            <Icon name="log-out-outline" />
            <Text>Leave Organization…</Text>
          </Item>
        </Link>
      ) : null}
    </Card>
  ) : null;
}
